import {CHOSE_STATION} from '../types';

const initialState = {
    isChosed: false
};

export const switchingStation = (state=initialState, action) => {
    //console.log(action.stationAttributes)
    switch (action.type) {
        case CHOSE_STATION:
            return{
                ...state,
                isChosed: !state.isChosed,
                ...action.stationAttributes
            };
        // case FETCH_DATA_REJECTED:
        //     return{
        //         ...state,
        //         isLoadingData: false,
        //         isFetchedData: false,
        //         error: action.payload.message
        //     };
        default:
            return state;
    }
};